const capabilities = ['Robotics Systems', 'Physical AI', 'Global Infrastructure'];

export default function CapabilitiesStrip() {
  return (
    <section className="border-t border-b border-brand-gray py-6 px-6">
      <div className="max-w-6xl mx-auto flex flex-wrap justify-center md:justify-between gap-6">
        {capabilities.map(cap => (
          <span key={cap} className="text-sm font-medium text-brand-text/50 tracking-widest uppercase">
            {cap}
          </span>
        ))}
      </div>
    </section>
  );
}
